import request from './request';

// 接口管理
function post1(param) {
    return request.post('posttest', param);
}

/**
 * 登录
 */
function login(param) {
    return request.post('login', param);
}

/** 
 * 获取用户的项目列表
*/
function getproject() {
    return request.get('getproject');
}

/**
 * 获取素材列表
 */
function getmaterial(param) {
    return request.post('getmaterial', param);
}

/**
 * 获取项目列表
 */
function getprojectlist(param) {
    return request.post('getprojectlist', param);
}

/** 获取项目管理列表(带文件夹) */
export function getprolistAPI(param) {
    return request.post('Getprojectlist', param);
}

/**获取会员信息 */
function getuserinfo() {
    return request.get('getuserinfo');
}

/** 
 * 新建素材文件夹
 */
export function createMaterialDirAPI(param) {
    return request.post('Material/createMaterialDir', param);
}

/**
 * 上传素材信息
 */
export function upmaterial(data, config) {
    return request.post('upmaterial', data, config);
}

/**
 * 删除素材文件
 */
export function delmaterial(param) {
    return request.post('delmaterial', param);
}

/**
 * 素材重命名
 */
export function renameMaterialAPI(param) {
    return request.post('Material/renameMaterial', param);
}

/** 
 * 素材移动
 */
export function moveMaterialAPI(param) {
    return request.post('Material/removeMaterial', param);
}

/** 素材图文上传 */
export function materialEditorUpAPI(param) {
    return request.post('Material/editorUp', param);
}
/** 图文更新 */
export function materialEditorUpdateAPI(param) {
    return request.post('Material/editorRevise', param);
}
/** 图文素材删除 */
export function materialDelAPI(param) {
    return request.post('Material/editorDel', param);
}

/**
 * 创建项目
 */
export function createproject(param) {
    return request.post('Createproject', param);
}

/** 删除项目 */
export function delProjectAPI(param) {
    return request.post('Projectinfo/delProject', param);
}

/**
 * 上传项目资料
 */
export function upprojectdata(param, config) {
    return request.post('Upprojectdata/resUpload', param, config);
}

/**
 * 修改用户信息
 */
export function Changeuserinfo(param) {
    return request.post('changeuserinfo', param);
}

/**
 * 上传头像信息
 */
export function Changeuseravatar(param) {
    return request.post('changeuseravatar', param);
}
export { post1, login, getproject, getmaterial, getprojectlist, getuserinfo };

/** 获取表单设置信息 */
export function getFormSettingInfo(param) {
    return request.post('Projectinfo/getFormSetting', param);
}
/** 设置表单信息 */
export function setFormInfo(param) {
    return request.post('Projectinfo/setForm', param);
}
/** 提交表单内容 */
export function submitFormInfo(param) {
    return request.post('Projectinfo/getFormInfo', param);
}

/** 获取客服数据 */
export function getCustServiceDataAPI(param) {
    return request.post('Service/Servicelist', param);
}
/** 创建客服 */
export function createCustServiceAPI(param) {
    return request.post('Service/createService', param);
}
/** 编辑客服 */
export function editCustServiceAPI(param) {
    return request.post('Service/editService', param);
}
/** 搜索客服 */
export function searchCustServiceAPI(param) {
    return request.post('Service/serviceSreach', param);
}
/** 删除客服 */
export function delCustService(param) {
    return request.post('Service/delService', param);
}
/** 获取客服的公司名称 */
export function getCompanyAPI() {
    return request.get('service/getCompany');
}
/** 根据客服公司名称搜索客服 */
export function getByNameCustServiceAPI(param) {
    return request.post('service/compantSearchService', param);
}
/** 保存客服设置 */
export function saveCustServiceInfoAPI(param) {
    return request.post('Service/saveService', param);
}
/** 根据项目id获取客服列表 */
export function getByProIdCustListAPI(param) {
    return request.post('Service/getProjectService', param);
}

/** 项目搜索 */
export function getByNameProjectAPI(param) {
    return request.post('Projectinfo/projectSearch', param);
}
/** 项目文件夹删除 */
export function delDirAPI(param) {
    return request.post('Projectinfo/delProjectVir', param);
}
/** 项目文件夹重命名 */
export function renameDirAPI(param) {
    return request.post('Projectinfo/changeProjectVirName', param);
}
/** 项目重命名 */
export function renameProAPI(param) {
    return request.post('Projectinfo/renameProject', param);
}
/** 创建项目文件夹 */
export function createProjectDirAPI(param) {
    return request.post('Projectinfo/createProjectVir', param);
}
/** 获取项目类型列表 */
export function getProjectTypesOfList() {
    return request.get('Projectinfo/typesof');
}
/** 根据项目类型获取项目信息 */
export function getByTypesOfProInfoAPI(param) {
    return request.post('Projectinfo/typesofSearch', param);
}
/** 移动项目 */
export function moveProjectToDir(param) {
    return request.post('Projectinfo/removeProjectToVir', param);
}

/** 获取推送信息列表 */
export function getPushListAPI() {
    return request.get('push/pushlist');
}
/** 获取未读消息列表 */
export function getNoReadMessageAPI() {
    return request.get('push/noReadPush');
}
/** 返回已读的消息 */
export function returnReadMessageAPI(param) {
    return request.post('push/readPush', param);
}

/** 获取容量信息 */
export function getCapacityAPI() {
    return request.get('getCapacity/getCapacity');
}

/** 续费 */
export function userRenewAPI(param) {
    return request.post('pay/renew', param);
}
/** 扫码支付 */
export function scanCodePaymentRenewAPI(param) {
    return request.post('pay/preScanOrder', param);
}

/** 微信绑定 */
export function bindWxAPI() {
    return request.post('wechat/wechatBing');
}
/** 绑定成功 */
export function getOpenidBindAPI(param) {
    return request.post('wechat/getOpenidBing', param);
}
/** 解绑 */
export function unBindingWxAPI() {
    return request.get('wechat/unbind');
}

/** 订单管理 */
export function getOrderListAPI() {
    return request.get('Order/getOrderList');
}
/** 支付订单 */
export function toPayAPI(param) {
    return request.post('pay/topay', param)
}

/**
 * 获取注册二维码
 */
export function getTicket() {
    return request.get('wechat/getTicket');
}

/**
 * 发送注册验证码
 */
export function sendCode(param) {
    return request.post('wechat/sendCode', param)
}
/**
 * 重新获取注册二维码
 */
export function reTicket(param) {
    return request.post('wechat/reTicket', param)
}

/**
 * 检查短信验证码
 */
export function checkCode(param) {
    return request.post('wechat/checkCode', param)
}

/** 帮助文档 */
export function getHelpDocumentAPI() {
    return request.get('Usingtutorials/getTutorials');
}

/** 项目回收站列表 */
export function getProjectRecyclebinAPI() {
    return request.get('Projecthandle/ProjectRecyclebin');
}
/** 项目回收站还原-要还原的文件列表 */
export function getProVirListAPI() {
    return request.get('Projecthandle/projectVirList');
}
/** 项目回收站项目还原 */
export function reductionProAPI(param) {
    return request.post('Projecthandle/RestoreProject', param);
}
/** 项目回收站删除 */
export function delCompletelyAPI(param) {
    return request.post('Projecthandle/CompletelyDelete', param);
}

/** 素材回收站列表 */
export function getMaterialListAPI() {
    return request.get('Projecthandle/materialRecycleBin');
}
/** 素材回收站还原-要还原的文件目录 */
export function getMaterialVirAPI(param) {
    return request.post('Projecthandle/materialVirtual', param);
}
/** 素材回收站还原 */
export function reductionMaterialAPI(param) {
    return request.post('Projecthandle/reductionMaterial', param);
}
/** 素材回收站删除 */
export function delMaterialAPI(param) {
    return request.post('Projecthandle/delMaterial', param);
}


// 首页用到的API
/** 获取banner信息 */
export function getBannerAPI() {
    return request.get('Homepage/banner');
}
/** 获取首页的一些基础信息，联系电话，产品数，品牌数，浏览量 */
export function getBasedataAPI() {
    return request.get('Homepage/basedata');
}
/** 获取产品服务的信息列表 */
export function getProductServicesAPI() {
    return request.get('Homepage/productServices');
}
/** 获取应用案例的信息列表 */
export function getAppCasesAPI() {
    return request.get('Homepage/appCases');
}
/**  每次打开应用案例的浏览量加一 */
export function setCasesViewAPI(param) {
    return request.post('Homepage/addAppCasesView', param);
}
/** 提交详情咨询信息 */
export function submitConsultInfoAPI(param) {
    return request.post('homepage/consult', param);
}

/** 获取转换工具下载地址 */
export function getToolSrcAPI() {
    return request.get('homepage/tool');
}

/**获取预约的设置的配置 */
export function getGetAppointmentAPI(param) {
    return request.post('Reservation/GetAppointment', param);
}
/**设置节假日的预约 */
export function getSetHolidayYuyueAPI(param) {
    return request.post('Reservation/setHolidayYuyue', param);
}
/**节假日的列表 */
export function getHolidayYuyueListAPI(param) {
    return request.post('Reservation/HolidayYuyueList', param);
}
/**删除节假日 */
export function getDelHolidayYuyueAPI(param) {
    return request.post('Reservation/delHolidayYuyue', param);
}
/**新增日常的预约设置 */
export function getAddweektimeslotApi(param) {
    return request.post('Reservation/addweektimeslot', param);
}
/**日常预约的修改 */
export function getSetDailyNumApi(param) {
    return request.post('Reservation/setDailyNum', param);
}
/**日常预约时间段的删除 */
export function getDelWeekTimeslotApi(param) {
    return request.post('Reservation/delWeekTimeslot', param)
}

/**获取留言列表 */
export function getProjectLeaveWordApi(param) {
    return request.post('Reservation/projectLeaveWord', param)
}
/**显示或者隐藏用户留言 */
export function getshowLeaveWordApi(param) {
    return request.post('Reservation/showLeaveWord', param)
}
/**删除用户留言 */
export function getdelLeaveWordApi(param) {
    return request.post('Reservation/delLeaveWord', param)
}
/**获取所有的预约游客列表 */
export function gethasReservationVisitorApi(param) {
    return request.post('Reservation/hasReservationVisitor', param)
}
/** 获取或者改变项目预约状态*/
export function getChangeReservationApi(param) {
    return request.post('Reservation/changeReservation', param)
}
/**获取日期将来的预定时间段 */
export function getChangeStartDayApi(param) {
    return request.post('Reservation/changeStartDay', param)
}
/**获取或者改变项目入馆须知 */
export function getentrynoticeApi(param) {
    return request.post('Reservation/entrynotice', param)
}
/**获取或者改变项目展馆公告 */
export function getExhibitionNoticeApi(param) {
    return request.post('Reservation/ExhibitionNotice', param)
}